import type { FC } from 'react';
import { DrawerSection } from '@components/DrawerSection';
import Icon from '@components/Icon';
import { blockQueries } from '@queries/fetchBlocks';
import { useQuery } from '@tanstack/react-query';

import { useBlockPanelContent } from '../hooks/useBlockPanelContent';

import { ContractPillSkeleton } from './ContractPillSkeleton';

interface DrawerParentBlockNameProps {
  isBlock: boolean;
  parentBlockId?: string;
}

export const DrawerParentBlockName: FC<DrawerParentBlockNameProps> = ({ isBlock, parentBlockId }) => {
  const { getContent } = useBlockPanelContent(isBlock);

  const { data: parentBlock, isLoading } = useQuery({
    ...blockQueries.detail(parentBlockId as string),
    enabled: !!parentBlockId,
  });

  if (!parentBlockId) return null;

  return (
    <DrawerSection title={getContent('fields.parent.label')}>
      <div className="text-info-500 flex cursor-default items-start gap-1 text-sm">
        <Icon name="block-parent" />
        {isLoading ? <ContractPillSkeleton /> : parentBlock?.data?.name}
      </div>
    </DrawerSection>
  );
};
